// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preNextOne.nav-btn-group .nav-btn-Previous,.preNextTwoHide.nav-btn-group .nav-search{right:5px}", ""]);
// Exports
module.exports = exports;
